import { useState } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import ServicesMarquee from "@/components/ServicesMarquee";
import Services from "@/components/Services";
import Portfolio from "@/components/Portfolio";
import Pricing from "@/components/Pricing";
import Process from "@/components/Process";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import CTABanner from "@/components/CTABanner";
import Footer from "@/components/Footer";
import LeadFormDialog from "@/components/LeadFormDialog";
import BookCallDialog from "@/components/BookCallDialog";
import AnnouncementBar, { isPromoActive } from "@/components/AnnouncementBar";

export default function Home() {
  const [leadOpen, setLeadOpen] = useState(false);
  const [bookOpen, setBookOpen] = useState(false);
  const promoActive = isPromoActive();

  return (
    <div data-testid="home-page" className="relative">
      {promoActive && <AnnouncementBar />}
      <Navbar
        hasBanner={promoActive}
        onOpenLead={() => setLeadOpen(true)}
        onOpenBookCall={() => setBookOpen(true)}
      />
      <Hero
        onOpenLead={() => setLeadOpen(true)}
        onOpenBookCall={() => setBookOpen(true)}
      />
      <ServicesMarquee />
      <Services />
      <Portfolio />
      <Pricing />
      <Process />
      <Testimonials />
      <CTABanner onOpenLead={() => setLeadOpen(true)} />
      <FAQ />
      <Footer />
      <LeadFormDialog open={leadOpen} onOpenChange={setLeadOpen} />
      <BookCallDialog open={bookOpen} onOpenChange={setBookOpen} />
    </div>
  );
}
